"use client";

import { useState } from "react";

/** Long reviews show their first lines with a "Read more" toggle, so one long
 *  quote does not set the height of the whole strip. The full text is always
 *  in the DOM (CSS line clamp only); nothing is edited or cut. */
const LONG = 170;

export default function ReviewQuote({
  quote,
  rtl,
  more,
  less,
}: {
  quote: string;
  rtl?: boolean;
  more: string;
  less: string;
}) {
  const [open, setOpen] = useState(false);
  const long = quote.length > LONG;
  return (
    <div className="mb-5">
      <p
        className={`font-serif text-[16.5px] leading-snug text-ss-text ${long && !open ? "line-clamp-5" : ""}`}
        dir={rtl ? "rtl" : undefined}
      >
        &ldquo;{quote}&rdquo;
      </p>
      {long && (
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
          className="mt-2 text-[13.5px] font-semibold text-ss-blue underline underline-offset-2"
        >
          {open ? less : more}
        </button>
      )}
    </div>
  );
}
